<div id="modal-content-wrapper">
  <form #f="ngForm" (ngSubmit)="submit()">
    <div class="modal-header justify-content-center">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div class="modal-body">
      <!-- Product -->
      <div>
        <label>Shopify Product</label>
        <div class="form-group mb-3">
          <select
            class="form-select"
            name="product"
            [(ngModel)]="product"
            [class.is-invalid]="!isValidProduct()"
            (ngModelChange)="model.product = $event.id"
            required
          >
            <option *ngFor="let opt of products" [ngValue]="opt">{{ opt?.title }}</option>
          </select>
          <div *ngIf="products.length == 0" class="warning">
            No unassigned products found. Please add a product to shopify and reaload this page.
          </div>
        </div>
      </div>

      <!-- Mail Template -->
      <div>
        <label>Mail Template</label>
        <div class="form-group mb-3">
          <select class="form-select" name="mail" [(ngModel)]="model.mail" [class.is-invalid]="!isValidMail()" required>
            <option *ngFor="let opt of mails" [ngValue]="opt">{{ opt }}</option>
          </select>
        </div>
      </div>

      <!-- Pattern -->
      <div>
        <label>Licence Key Pattern</label>
        <div class="form-group mb-3">
          <input
            type="text"
            name="licence"
            [(ngModel)]="model.pattern"
            class="form-control"
            [class.is-invalid]="!isValidPattern()"
            autocomplete="off"
            required
          />
        </div>
        <div class="info">Example key for this pattern: <code>{{ exampleKey }}</code></div>
        <div class="info">
          The following placeholders can be used to generate new licence keys:<br />
          <code>?</code> generates a random alphanumeric character<br />
          <code>_</code> generates a random letter<br />
          <code>#</code> generates a random number<br />
        </div>
      </div>

      <!-- Roles -->
      <div>
        <label>Roles</label>
        <div class="form-group mb-3">
          <role-selector
            ngModel
            name="roles"
            [selection]="model.profile.meta.roles"
            [roles]="roles"
            (onSelect)="model.profile.meta.roles = $event"
            class="form-control"
            [class.is-invalid]="!isValidRoles()"
          >
          </role-selector>
        </div>
      </div>

      <!-- Volume -->
      <div>
        <label>Volume</label>
        <div class="form-group mb-3">
          <input
            type="number"
            name="volume"
            [(ngModel)]="model.volume"
            class="form-control"
            [class.is-invalid]="model.volume <= 0"
            min="1"
          />
        </div>
      </div>

      <!-- Usage -->
      <div>
        <label>Licence Usage</label>
        <div class="form-group mb-3">
          <select class="form-select" name="usage" [(ngModel)]="model.usage" [class.is-invalid]="model.usage == null" required>
            <option value="registration">registration</option>
            <option value="empowerment">empowerment</option>
            <option value="unrestricted">unrestricted</option>
          </select>
          <div class="info">{{ licenceUsageInfo[model.usage] }}</div>
        </div>
      </div>

      <!-- Duration -->
      <div>
        <label>Duration</label>
        <div class="form-group mb-3">
          <duration-picker [(value)]="model.profile.meta.duration"></duration-picker>
        </div>
      </div>

      <!-- Buttons -->
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!f.form.valid || !isValid()">Submit</button>
      </div>
    </div>
  </form>
</div>
